import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  DialogActions,
  IconButton,
  InputLabel,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import {TiFolderOpen} from 'react-icons/ti';
import {useDropzone} from 'react-dropzone';
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {FETCH_ERROR} from 'shared/constants/ActionTypes';
import {grey} from '@mui/material/colors';
import {ButtonContained} from 'shared/components/Button';
import {useState} from 'react';
import {getFileSize} from '@crema/utility/Utils';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment'
import {
  onAddDocumentDigisignPk,
  onApproveDocumentDigisign,
} from 'redux/actions/DigitalSign';

const ModalSign = ({
  open,
  dataDokumen,
  handleClose,
  isPassphrase = false,
  textUpload = 'Hanya file xlsx yang akan diterima dan ukuran file maks 50 MB',
}) => {
  const dispatch = useDispatch();
  const [uploadedFile, setuploadedFile] = useState(null);
  const [passphrase, setPassphrase] = useState('');
  const [attachmentId, setAttachmentId] = useState('');
  const [signState, setSignState] = useState(false);
  const onDrop = useCallback((acceptedFiles, fileRejections) => {
    if (fileRejections.length !== 0 && acceptedFiles.length === 0) {
      dispatch({
        type: FETCH_ERROR,
        payload: 'Tipe File Tidak Mendukung',
      });
    } else {
      const size = (acceptedFiles[0].size / 1024 / 1024).toFixed(3);
      if (size <= 50) {
        setuploadedFile(acceptedFiles[0]);
      } else {
        dispatch({
          type: FETCH_ERROR,
          payload: 'Ukuran File Maksimal 50 MB',
        });
      }
    }
  }, []);

  const handleUploadFile = () => {
    if (dataDokumen.length === 0) {
      dispatch(onAddDocumentDigisignPk(uploadedFile));
      setuploadedFile(null);
      handleClose();
    } else {
      handleBulkApprove();
    }
  };

  const handleBulkApprove = () => {
    let data = {
      passphrase: passphrase,
      id_documents: dataDokumen,
      sign_date: moment().format('DD MMMM YYYY'),
    };
    dispatch(onApproveDocumentDigisign(data));
    setTimeout(() => {
      setuploadedFile(null);
      handleClose();
    }, 3000);
  };

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'application/': ['.pdf', '.xlsx'],
    },
  });

  return (
    <div>
      <Dialog fullWidth open={open} onClose={handleClose}>
        <DialogContent sx={{p: 0}}>
          <Box className='p-4 d-flex flex-column' gap={8}>
            <Stack className='d-flex flex-row justify-content-between align-items-center'>
              <h2>{dataDokumen.length > 0 ? 'Bulk Approve' : 'Upload File'}</h2>
              <IconButton
                sx={{
                  padding: 1.5,
                  fontSize: 16,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleClose();
                }}
              >
                <CloseIcon sx={{fontSize: 18}} />
              </IconButton>
            </Stack>
            {!uploadedFile && dataDokumen.length === 0 && (
              <Box
                sx={{
                  position: 'relative',
                  '& ul': {
                    listStyle: 'none',
                    padding: 0,
                  },
                }}
              >
                <Box
                  {...getRootProps({className: 'dropzone'})}
                  sx={{
                    height: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    border: (theme) => `dashed 2px ${theme.palette.divider}`,
                    borderRadius: 2.5,
                    p: 5,
                    textAlign: 'center',
                    mb: 4,
                    color: 'text.secondary',
                    backgroundColor: grey[100],
                  }}
                >
                  <input {...getInputProps()} />
                  <TiFolderOpen
                    style={{
                      fontSize: 60,
                      marginBottom: 4,
                      color: grey[500],
                    }}
                  />
                </Box>
                <span>
                  *)
                  {isPassphrase
                    ? 'Hanya pdf yang akan diterima dan ukuran file maks 50 MB'
                    : textUpload}
                </span>
              </Box>
            )}

            {uploadedFile && (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  border: (theme) => `solid 1px ${theme.palette.divider}`,
                  mb: 2.5,
                  borderRadius: 2.5,
                  p: 2.5,
                  cursor: 'pointer',
                }}
              >
                <Box sx={{mr: 3}}>
                  <InsertDriveFileIcon />
                </Box>
                <Box sx={{flex: 1}}>
                  <Typography>{uploadedFile.name}</Typography>
                  <Box
                    component='span'
                    sx={{
                      color: 'text.secondary',
                    }}
                  >
                    {getFileSize(uploadedFile.size)}
                  </Box>
                </Box>
                <IconButton
                  sx={{
                    padding: 1.5,
                    fontSize: 16,
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    setuploadedFile(null);
                  }}
                >
                  <CloseIcon sx={{fontSize: 18}} />
                </IconButton>
              </Box>
            )}
            {dataDokumen.length > 0 && (
              <Box>
                <TextField
                  fullWidth
                  name='noSertif'
                  type='password'
                  placeholder='Masukan Passphrase'
                  variant='outlined'
                  value={passphrase}
                  onChange={(e) => setPassphrase(e.target.value)}
                />
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant='contained'
            size='small'
            style={{
              width: '100px',
              backgroundColor: '#F5F5F5',
              color: '#9F9F9F',
            }}
            onClick={handleClose}
          >
            BATAL
          </Button>

          <ButtonContained variant='contained' onClick={handleUploadFile}>
            SIMPAN
          </ButtonContained>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ModalSign;

ModalSign.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  isPassphrase: PropTypes.bool,
  dataDokumen: PropTypes.any,
  textUpload: PropTypes.string,
};
